import { Middleware } from 'redux';
import { configureStore, PayloadAction } from '@reduxjs/toolkit';
import { tileReducer, tileSliceCachedActions } from './tile.slice';
import { userReducer, userSliceCachedActions } from './user.slice';
import { roomSceneReducer, roomSceneSliceCachedActions } from './roomScene.slice';

export const inclusiveCache = [
  ...tileSliceCachedActions,
  ...userSliceCachedActions,
  ...roomSceneSliceCachedActions,
];

export const cacheMiddleware: Middleware = () => (next) => (action: unknown) => {
  const { type, payload } = action as PayloadAction<unknown>;
  if (payload !== null) {
    if (inclusiveCache.includes(type)) {
      localStorage.setItem(type, JSON.stringify(payload));
    }
  } else {
    localStorage.removeItem(type);
  }

  next(action);
};

export const store = configureStore({
  reducer: {
    tile: tileReducer,
    user: userReducer,
    roomScene: roomSceneReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(cacheMiddleware),
});
